import { useState, useEffect } from 'react';

export default function useUser() {
  const getUser = () => {
  
    var user = localStorage.getItem('user') || null;
    if (!user || user === 'undefined' || user === 'null') {
      return null
    }
    user = JSON.parse(localStorage.getItem('user'));

    return user
  };

  const [user, setUser] = useState(getUser());

  const saveUser = user => {
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    window.dispatchEvent(new CustomEvent('sync_user', { detail: user }));
  };

  useEffect(() => {
    const handleLogin = (event) => {
      if (event.detail && event.detail.user) {
        saveUser(event.detail.user);
      }
    };
    const handleSync = (event) => {
      setUser(event.detail);
    };
    window.addEventListener('login', handleLogin);
    window.addEventListener('sync_user', handleSync);
    return () => {
      window.removeEventListener('login', handleLogin);
      window.removeEventListener('sync_user', handleSync);
    };
  }, []);
  return {
    setUser: saveUser,
    user
  }
}